import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BuildingYourVision from "./sections/BuildingYourVision";
import OurSignatureSpaces from "./sections/OurSignatureSpaces";
import TheSnapExperience from "./sections/TheSnapExperience";
import TheUbudAdvantage from "./sections/TheUbudAdvantage";
import SignatureExperiences from "./sections/SignatureExperiences";
import ContactUsDirectly from "./sections/ContactUsDirectly";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BuildingYourVision />
      <OurSignatureSpaces />
      <TheSnapExperience />
      <TheUbudAdvantage />
      <SignatureExperiences />
      <ContactUsDirectly />
      <Footer />
    </div>;
}